import { MaintainConfig } from '@lib/services/_api';
import client from '@lib/services/client';

export const paging = client.api.maintainConfigControllerList;

export const getAll = () => {
  return client.api.maintainConfigControllerGetAll();
};

export const upsert = (data: MaintainConfig) => {
  return client.api.maintainConfigControllerUpsert(data);
};

export const deleteById = (id: any) => {
  return client.api.maintainConfigControllerDeleteById(id);
};
